export default {"src":"/_next/static/media/database-encryption.94129485.svg","height":50,"width":50,"blurWidth":0,"blurHeight":0};